export default "__VITE_ASSET__SOobirV6__"